import type { CombinedError } from "@urql/core"

import { ErrorTypeEnum } from "@/graphql/codegen/graphql"

export const PERMISSION_DENIED_MUTATION_MESSAGE =
  "You don't have permission to make this change. Contact your administrator to request access."

export const isForbiddenError = (error?: CombinedError): boolean =>
  error?.graphQLErrors?.some((graphQLError) => graphQLError.extensions?.code === ErrorTypeEnum.Forbidden) ?? false
